import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { parseSEODate } from '@beef/shop-common';

import { rateFeedback } from 'store/ProductDetails/feedbackLocal/actions';
import { Grid, Col, FiveStarRate, ThumbRate, TagsList, TagsItem, CollapseText } from 'bricks';
import commonStyles from 'styles/common.pcss';

import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

const FeedbackPost = ({
  id,
  title,
  isMostUseful,
  children,
  author,
  date,
  rating,
  likes,
  dislikes,
  isLiked,
  isDisliked,
  isRated,
  onRateFeedback,
  isCompact,
  publishDate,
  isMobile,
}) => (
  <div itemProp="review" itemScope itemType="http://schema.org/Review" className={cx('component')}>
    <meta itemProp="name" content={title} />
    <Grid className={cx('content')}>
      <Col size={isCompact ? 12 : 3}>
        <div className={cx(isMobile && 'dateWrap')}>
          <div itemProp="author" className={cx('author')}>
            {author}
          </div>
          <meta itemProp="datePublished" content={parseSEODate(publishDate)} />
          <div className={cx('date', /* 'marb-xs', */ isMobile && 'mobile')}>{date}</div>
        </div>
        <div
          is
          itemProp="reviewRating"
          itemScope
          itemType="http://schema.org/Rating"
          className={cx(isCompact ? 'push' : null)}
        >
          <meta itemProp="worstRating" content="1" />
          <meta itemProp="ratingValue" content={rating} />
          <meta itemProp="bestRating" content="5" />
        </div>
      </Col>
      <Col size={isCompact ? 12 : 9}>
        <div className={cx('rating', isMobile && 'mobile')}>
          <FiveStarRate value={rating} />
          <div className={cx('tagsWrap', isMobile && 'mobile')}>
            {isMostUseful ?
              <TagsList>
                <TagsItem color="#5c3cc0">Самый полезный отзыв</TagsItem>
              </TagsList>
            : null}
          </div>
        </div>
        <div className={cx('marb-xs')}>
          <CollapseText
            showText="Читать полностью"
            hideText="Скрыть текст"
            length={440}
            textAttrs={{ itemProp: 'description' }}
          >
            {children}
          </CollapseText>
        </div>
        <ThumbRate
          {...{ likes, dislikes, isLiked, isDisliked }}
          isDisabled={isRated}
          onLike={() => onRateFeedback({ isPositive: true, feedbackId: id })}
          onDislike={() => onRateFeedback({ isPositive: false, feedbackId: id })}
        />
      </Col>
    </Grid>
  </div>
);

FeedbackPost.propTypes = {
  isCompact: PropTypes.bool, // if true, post is output in one column
  id: PropTypes.number, // identifier of feedback
  title: PropTypes.node, // feedback title
  children: PropTypes.node, // feedback content
  isMostUseful: PropTypes.bool, // shows extra most useful tag
  author: PropTypes.string, // author name
  date: PropTypes.string, // date as pure text, no transformations applied
  publishDate: PropTypes.string,
  rating: PropTypes.number, // how many stars author gave the the product
  likes: PropTypes.number, // number of likes for the post
  dislikes: PropTypes.number, // number of dislikes for the post
  isMobile: PropTypes.bool,

  /**
   * does not point if its liked or disliked, just shows if its rated or not
   * includes isLiked, isDisliked and deprecated rated status
   */
  isRated: PropTypes.bool,
  isLiked: PropTypes.bool, // used when post is liked
  isDisliked: PropTypes.bool, // used when post is disliked
  onRateFeedback: PropTypes.func, // like or dislike feedback, takes { isPositive, feedbackId }
};

const mapDispatchToProps = {
  onRateFeedback: rateFeedback,
};

export default connect(null, mapDispatchToProps)(FeedbackPost);
